import { Link } from "@/components/common/Link";
import { useState, useEffect } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | number | null>(null);
  const [mobileExpanded, setMobileExpanded] = useState<string | number | null>(null);
  if (loading) {
    return <div className="h-10 w-20 animate-pulse bg-gray-100 rounded" />;
  }
  return <>
      <Link to="https://goldgaragedoor.com.au" className="flex items-center" aria-label="Gold Garage Door — home">
        <WvcLogo className="h-7 w-auto" />
      </Link>
      <nav className="hidden lg:flex items-center" style={{
      gap: "28px"
    }}>
        {menuItems.map((item: any, i: number) => {
        const hasChildren = item.children && item.children.length > 0;
        const isOpen = openDropdown === item.id;
        return <div key={item.id} data-index={i} className="relative" onMouseEnter={() => hasChildren && setOpenDropdown(item.id)} onMouseLeave={() => setOpenDropdown(null)}>
              <Link to={item.href || "#"} className="flex items-center gap-1 transition-colors duration-150 hover:text-amber-500" style={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#111111",
            textDecoration: "none",
            paddingTop: "10px",
            paddingBottom: "10px"
          }}>
                {item.label}
                {hasChildren && <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease"
            }}>
                    <path d="M3 4.5L6 7.5L9 4.5" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>}
              </Link>
              {hasChildren && isOpen && <div style={{
            position: "absolute",
            left: 0,
            top: "100%",
            minWidth: "280px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
            border: "1px solid #F0F0F0",
            padding: "8px",
            zIndex: 100
          }}>
                  {item.children.map((child: any) => <Link key={child.id} to={child.href || "#"} style={{
              padding: "10px 14px",
              fontSize: "14px",
              fontWeight: 500,
              color: "#222222",
              textDecoration: "none",
              borderRadius: "6px",
              display: "block",
              transition: "background-color 0.15s, color 0.15s"
            }} onMouseEnter={e => {
              (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "#FFF7E6";
              (e.currentTarget as HTMLAnchorElement).style.color = "#B45309";
            }} onMouseLeave={e => {
              (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "transparent";
              (e.currentTarget as HTMLAnchorElement).style.color = "#222222";
            }}>
                      {child.label}
                    </Link>)}
                </div>}
            </div>;
      })}
      </nav>

      <div className="hidden lg:flex items-center" style={{
      gap: "16px"
    }}>
        <Link to="tel:0485000933" className="flex items-center gap-2 transition-colors duration-150 hover:text-amber-500" style={{
        fontSize: "15px",
        fontWeight: 600,
        color: "#111111",
        textDecoration: "none"
      }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328z" fill="#111111" />
          </svg>
          0485 000 933
        </Link>
        <Link to="#contact-us" className="inline-flex items-center justify-center rounded-md transition-all duration-200 hover:opacity-90 hover:scale-105 cursor-pointer" style={{
        backgroundColor: "#F59E0B",
        color: "#FFFFFF",
        fontSize: "15px",
        fontWeight: 700,
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingLeft: "20px",
        paddingRight: "20px",
        borderRadius: "6px",
        textDecoration: "none",
        whiteSpace: "nowrap"
      }}>
          Free Quote
        </Link>
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetTrigger asChild>
          <button className="lg:hidden flex flex-col justify-center items-center gap-1 p-2 cursor-pointer" aria-label="Open menu">
            <span className="block w-5 h-0.5 bg-gray-800"></span>
            <span className="block w-5 h-0.5 bg-gray-800"></span>
            <span className="block w-5 h-0.5 bg-gray-800"></span>
          </button>
        </SheetTrigger>
        <SheetContent side="right" className="w-72">
          <SheetHeader>
            <SheetTitle className="text-left">
              <span style={{
              color: "#F59E0B",
              fontWeight: 700
            }}>Gold</span>
              <span style={{
              color: "#111111",
              fontWeight: 700
            }}> Garage Door</span>
            </SheetTitle>
          </SheetHeader>
          <nav className="flex flex-col mt-6" style={{
          gap: "4px"
        }}>
            {menuItems.map((item: any, i: number) => {
            const hasChildren = item.children && item.children.length > 0;
            const isExpanded = mobileExpanded === item.id;
            return <div key={item.id} data-index={i}>
                  {hasChildren ? <>
                      <button onClick={() => setMobileExpanded(isExpanded ? null : item.id)} className="w-full flex items-center justify-between" style={{
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#111111",
                  padding: "12px 0",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  textAlign: "left"
                }}>
                        <span>{item.label}</span>
                        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
                    transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease"
                  }}>
                          <path d="M3 4.5L6 7.5L9 4.5" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                      {isExpanded && <div style={{
                  paddingLeft: "16px",
                  paddingBottom: "8px",
                  borderLeft: "2px solid #F59E0B",
                  marginLeft: "4px",
                  marginBottom: "8px"
                }}>
                          <Link to={item.href || "#"} onClick={() => setMobileOpen(false)} style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#B45309",
                    padding: "8px 0",
                    textDecoration: "none"
                  }}>
                            View All →
                          </Link>
                          {item.children.map((child: any) => <Link key={child.id} to={child.href || "#"} onClick={() => setMobileOpen(false)} style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#444444",
                    padding: "8px 0",
                    textDecoration: "none"
                  }}>
                              {child.label}
                            </Link>)}
                        </div>}
                    </> : <Link to={item.href || "#"} onClick={() => setMobileOpen(false)} style={{
                display: "block",
                fontSize: "16px",
                fontWeight: 500,
                color: "#111111",
                padding: "12px 0",
                textDecoration: "none"
              }}>
                      {item.label}
                    </Link>}
                </div>;
          })}
            <div style={{
            height: "16px"
          }} />
            <Link to="tel:0485000933" className="flex items-center gap-2" style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#111111",
            textDecoration: "none",
            padding: "12px 0",
            borderTop: "1px solid #F0F0F0"
          }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328z" fill="#111111" />
              </svg>
              0485 000 933
            </Link>
            <Link to="#contact-us" onClick={() => setMobileOpen(false)} className="inline-flex items-center justify-center rounded-md" style={{
            backgroundColor: "#F59E0B",
            color: "#FFFFFF",
            fontSize: "15px",
            fontWeight: 700,
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingLeft: "20px",
            paddingRight: "20px",
            borderRadius: "6px",
            textDecoration: "none",
            marginTop: "8px"
          }}>
              Free Quote
            </Link>
          </nav>
        </SheetContent>
      </Sheet>
    </>;
}
export default function Header() {
  useEffect(() => {
    const imageUrl = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/technician-garage-door-repair.png";
    const existingLink = document.querySelector(`link[href="${imageUrl}"]`);
    if (!existingLink) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = imageUrl;
      link.type = 'image/webp';
      link.setAttribute('fetchpriority', 'high');
      link.setAttribute('imagesrcset', 'https://goldgaragedoor.com.au/wp-content/uploads/2026/05/technician-garage-door-repair-mobile.webp 768w, https://goldgaragedoor.com.au/wp-content/uploads/2026/05/technician-garage-door-repair-tablet.webp 1200w, https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/technician-garage-door-repair.png 1920w');
      link.setAttribute('imagesizes', '(max-width: 768px) 100vw, (max-width: 1200px) 90vw, 50vw');
      document.head.appendChild(link);
    }
  }, []);
  return <header id="header" className="sticky top-0 z-50 w-full bg-white" style={{
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    fontFamily: "Manrope, system-ui, sans-serif"
  }}>
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <MenuProvider menu_id="16" className="flex items-center justify-between w-full">
          <NavMenuContent />
        </MenuProvider>
      </div>
    </header>;
}